import React from 'react';
import PropTypes from 'prop-types';
import styles from './Table.scss';

function TableHeader({ columns, onSort, rows, sort, order }) {
    return (
        <div className={`${styles.TableHeader}`}>
            <ul>
                {columns.filter(({ hideColumn = false }) => !hideColumn).map((value, index) => {
                    const { headerClassName, sortable } = value;
                    const sortEl = order === 'asc' ? <div>&#9650;</div> : <div>&#9660;</div>;
                    return (
                        <li
                            key={index}
                            style={value.maxWidth ? { minWidth: `${value.maxWidth}px`,
                                width: `${value.maxWidth}px`,
                                flex: `${value.maxWidth} 0 auto` } : {}}
                            className={`${
                                sortable === false ? `${styles.unsortable}` : ''
                            } ${
                                value.key === sort ? `${styles[order]}` : `${styles.unsorted}`
                            } ${headerClassName || ''}`}
                            onClick={
                                Array.isArray(rows) && rows.length && value.sortable !== false
                                    ? () => onSort(value.key)
                                    : () => {}
                            }
                        >
                            <div
                                className={`${styles.TableHeaderTitle} ${
                                    value.key === sort ? '' : sortable !== false ? 'link' : ''
                                }`}
                            >
                                {typeof value.title === 'function' ? (
                                    value.title(value.key === sort)
                                ) : (
                                    <p>{value.title}</p>
                                )}
                                {sortable !== false && value.key === sort ? sortEl : ''}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

TableHeader.defaultProps = {
    columns: [],
    rows: [],
    sort: '',
    order: '',
    onSort: () => {},
};

TableHeader.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape),
    rows: PropTypes.arrayOf(PropTypes.shape),
    sort: PropTypes.string,
    order: PropTypes.string,
    onSort: PropTypes.func,
};

export default TableHeader;
